import get from 'lodash/get';
import * as dealInfoHelpers from '../../utils/deal-info-helpers';

export function isSubscribedTo(channel) {
  return Boolean(get(channel, 'dgsInfo.subscription'));
}

export function isSubscriptionEnabled(channel) {
  return Boolean(dealInfoHelpers.getSubscriptionPriceInfo(channel.dealInfo));
}

export function getDealInfo(props) {
  return get(props, 'channelData.dealInfo');
}



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/common/ui-selectors/channel/pricing.js